import PaymentWaiting from './PaymentWaiting.page';

export default PaymentWaiting;
